export const aboutData = {
  title: "About",
  description2:
    "Having experience of solving 100+ leetcode problems with time and memory efficiency.knowledge of wide variety of web technologies.having good grasp of calculus & linear algebra",
};
